import Cookies from "js-cookie";
import { logWithPrefix } from "@/plugins/logging";
import { api } from "@/plugins/api";
import utils from "@/plugins/utils";
import _ from "@/plugins/lodash";
import i18n from "@/plugins/i18n";
const defaultSettings = require("@/settings.js");
const log = logWithPrefix("[store/user.js]");
const TOKEN_KEY = "dniToken";
const CSRF_TOKEN_KEY = "dnicsrf";
const ARMOR_KEY = "dniPopup";

let info_inited = false;
const getDefaultState = () => {
  return {
    token: "",
    csrf: "",

    // For Armor
    never_remind_armor: false,
    armor_accredit_type: "trail",
    never_remind_adt: false,
    never_remind_app: false,

    gui_region: "English",
    user_gui_region: "Auto",
    changing_lang: false,
    board_region: "WW",
    sku: "WW",
    firm_version: "V1.0.0.0",
    host_name: "RAX10",
    hardware_verion: "Nighthawk® AX12 RAX10",
    device_mode: "router", // 'bridge', 'ap'

    has_new_version: false,
    menu_disabled: false,
    wps_active: "active",
    CircleStatus_activationStatus: "none",

    support: {
      auto_connect: false, // GR only
      pppoe_intranet: false, // RU only
      ds_lite: false, // JP only
      mulpppoe: false, // JP only
      vpn_passthrough: false, // PR & RU
      vpn_client: true, // Not PR
      ipmac: false, // PR
    },
  };
};
const state = getDefaultState();

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    Cookies.set(TOKEN_KEY, token);
    log("@mu(SET_TOKEN) token", token);
  },
  SET_USER(state, user) {
    state.getPermission = true;
    _.merge(state, user);
    log("@mu(SET_USER) state", state);
  },
  SET_CSRF(state, csrf) {
    state.csrf = csrf;
    log("@mu(SET_CSRF) state.csrf", state.csrf);
  },
  REMOVE_USER(state) {
    state.changing_lang = false;
    state.token = "";
    localStorage.removeItem(ARMOR_KEY);
    state.csrf = "";
    state.never_remind_armor = false;
    state.armor_accredit_type = "trail";
    state.never_remind_adt = false;
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ARMOR_KEY);
    localStorage.removeItem(CSRF_TOKEN_KEY);
    info_inited = false;
    log("@mu(REMOVE_USER) state", state);
  },
  SET_NEVER_REMIND_ARMOR(state, flag) {
    if (state.never_remind_armor) {
      return;
    }
    state.never_remind_armor = typeof flag == "undefined" ? true : flag == "1";
    log("@mu(SET_NEVER_REMIND_ARMOR) state.never_remind_armor", flag, state.never_remind_armor);
  },
  SET_ARMOR_INFO(state, info) {
    if (info.armor) {
      state.armor_accredit_type = info.armor.armor_accredit_type;
    } else {
      state.armor_accredit_type = "trail";
    }
    log("@mu(SET_ARMOR_INFO) state.armor_accredit_type", state.armor_accredit_type);
  },
  SET_NEVER_REMIND_ADT(state, flag) {
    log("never_remind_adt", state.never_remind_adt, flag);
    if (state.never_remind_adt) {
      return;
    }
    state.never_remind_adt = typeof flag == "undefined" ? true : flag == "1";
    log("@mu(SET_NEVER_REMIND_ADT) state.never_remind_adt", state.never_remind_adt);
  },
  SET_NEVER_REMIND_APP(state, flag) {
    state.never_remind_app = flag;
    log("@mu(SET_NEVER_REMIND_ADT) state.never_remind_app", state.never_remind_app);
  },
  SET_LANG(state, value) {
    state.gui_region = value;
    if (state.board_region === "WW") {
      if (state.gui_region === "German") {
        state.sku = "GR";
      } else if (state.gui_region === "Russian") {
        state.sku = "RU";
      } else if (state.gui_region === "Chinese") {
        state.sku = "PR";
      } else if (state.gui_region === "Japanese") {
        state.sku = "JP";
      } else {
        state.sku = "WW";
      }
    } else {
      state.sku = state.board_region;
    }
    state.support.vpn_passthrough = ["RU", "PR"].includes(state.sku);

    state.support.auto_conn = state.sku === "GR";
    state.support.ds_lite = 0;
    state.support.mulpppoe = state.sku === "JP";
    state.support.pppoe_intranet = state.sku === "RU";
    state.support.vpn_client = state.sku !== "PR";
    state.support.ipmac = state.sku === "PR";

    Cookies.set("locale", value);
    i18n.locale = value;
    log("localStorage > locale", Cookies.get("locale"));
    log("@mu(SET_LANG) state", state);
  },
  SET_DEVICE_MODE(state, mode) {
    state.device_mode = mode || "router";
    log("@mu(SET_DEVICE_MODE) state", state);
  },
  SET_USER_SELECT_LANG(state, lang) {
    //if (state.user_gui_region != "Auto") {
	if (lang != "auto") {
      state.user_gui_region = utils.transferConfig2Value("lang", "lang", lang);
    } else {
	  state.user_gui_region = "Auto";
    }
    log("@mu(SET_USER_SELECT_LANG) lang", lang);
  },
  SET_INFO(state, info) {
    if (!info) {
      return;
    }
    state.board_region = info.board_region || "WW";
    state.firm_version = info.firm_version || "";
    state.host_name = info.host_name || "";
    state.hardware_verion = info.hardware_verion || "";
    state.device_mode = info.device_mode || "router";
    state.menu_disabled = false;
    state.wps_active = info.wps_status || "active";
    mutations.SET_NEVER_REMIND_ARMOR(state, info.armor_never_remind);
    mutations.SET_ARMOR_INFO(state, info);
    mutations.SET_NEVER_REMIND_ADT(state, info.adt_never_remind);
    mutations.SET_NEVER_REMIND_APP(state, info.app_never_remind);
    mutations.SET_USER_SELECT_LANG(state, info.user_gui_region);
    mutations.SET_LANG(state, info.gui_region || "English");
    mutations.SET_HAS_NEW_VERSION(state, info);
    log("@mu(SET_INFO) state", state);
  },
  SET_LOCALE(state, lang) {
    const baseLang = i18n.getLocaleMessage("English");
    const local = i18n.getLocaleMessage(state.gui_region);
    const exist = Object.assign(baseLang, local);
    i18n.setLocaleMessage(state.gui_region, Object.assign(exist, lang));
    log("@mu(SET_LOCALE)", state.gui_region, state);
  },
  SET_HAS_NEW_VERSION(state, info) {
    if (info.wan_connected && info.wan_connected.wan_internet_connected) {
      if (
        info.new_version_info.have_new_firmware === "1" ||
        ( defaultSettings.type == 'router' && info.new_version_info.have_new_language == "1")
      ) {
        log("@mu(SET_HAS_NEW_VERSION)", state.has_new_version);
        state.has_new_version = true;
        return;
      }
    }
    state.has_new_version = false;
    log("@mu(SET_HAS_NEW_VERSION)", state.has_new_version);
  },
};
const actions = {
  login: async ({ commit }, data) => {
    const ret = await api.post("login", data);
    if (ret && ret.code === 0) {
      // 登录成功 > 设置 token

      commit("REMOVE_USER");
      commit("SET_TOKEN", ret.data.token);
      commit("SET_INFO", ret.data.info);
      commit("SET_LOCALE", ret.data.lang);
      info_inited = true;
    } else {
      // 登录失败 > 清除 token userInfo
      commit("REMOVE_USER");
    }
    return ret;
  },

  logout: async ({ commit }) => {
    // 登出 > 清除 token userInfo
    await api.post("logout", {}, false, "", false);
    commit("REMOVE_USER");
    localStorage.removeItem("storeCache");
  },
  timeout: async ({ commit }) => {
    commit("REMOVE_USER");
    localStorage.removeItem("storeCache");
  },
  getinfo: async ({ state, commit }) => {
    if (info_inited) {
      log("info_inited", true, state.device_mode);
      return { code: 0, data: { info: { device_mode: state.device_mode } } };
    }
    const info = await api.get("info");
    if (info && info.data && info.data.info) {
      commit("SET_INFO", info.data.info);
      commit("SET_LOCALE", info.data.lang);
      info_inited = true;
    }
    if (info && info.code) {
      commit("REMOVE_USER");
      localStorage.removeItem(TOKEN_KEY);
    }
    log("info", info);
    return info;
  },
  setInfo: ({ commit }, info) => {
    commit("SET_INFO", info);
  },

  // 加载页面时更新localStorage本地token到store
  updateToken: ({ commit }) => {
    const token = Cookies.get(TOKEN_KEY);
    if (token) {
      commit("SET_TOKEN", token);
    }
    return token;
  },

  // 设置token到localStorage 和 store
  setToken: ({ commit }, token) => {
    if (!token) {
      return;
    }
    Cookies.set(TOKEN_KEY, token);
    commit("SET_TOKEN", token);
    return token;
  },

  // 发送请求是带上token
  getToken: ({ state }) => {
    return state.token || Cookies.get(TOKEN_KEY);
  },

  // 设置token到localStorage 和 store
  setCsrfToken: ({ commit }, token) => {
    if (!token) {
      return;
    }
    Cookies.set(CSRF_TOKEN_KEY, token);
    commit("SET_CSRF", token);
    return token;
  },

  // 发送请求是带上token
  getCsrfToken: ({ state }) => {
    return state.csrf || Cookies.get(CSRF_TOKEN_KEY);
  },

  setArmor: ({ commit }, flag) => {
    commit("SET_NEVER_REMIND_ARMOR", !flag);
  },
  // Whether need to pop up Armor Box, true - Pop up;
  getArmor: ({ state }) => {
    return !state.never_remind_armor;
  },
  getArmorInfo: ({ state }) => {
    return state.armor_accredit_type;
  },
  setApp: ({ commit }, flag) => {
    commit("SET_NEVER_REMIND_APP", !flag);
  },
  getSupportedLangs: () => {
    return utils.langMapping().filter((o) => {
      return o.value != "Arabic";
    });
  },
  setLang: ({ commit }, value) => {
    commit("SET_LANG", value);
  },
  setUserSelect: ({ commit }, value) => {
    commit("SET_USER_SELECT_LANG", value);
  },
  loadLocaleLanguage: async ({ commit }) => {
    const ret = await api.get("locale");
    if (ret && ret.code == 0 && ret.data) {
      commit("SET_LOCALE", ret.data);
    }
    commit("SET_LOCALE", {});
  },
  setAdt: ({ commit }, value) => {
    commit("SET_NEVER_REMIND_ADT", value);
  },
  setWpsActive: async ({ state }, value) => {
    state.wps_active = value || "active";
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
